
import { Component, OnInit } from '@angular/core';
import { DataTable, LazyLoadEvent, Message, SelectItem } from 'primeng/primeng';
import { Router } from '@angular/router';
import { StorageService } from '../../services/system/storage.service';
import { ListingOptionsService } from '../../services/listing-options.service';
import { ListingOptionResponse, ViewTypeEnum } from '../../models/inModels/MarketPlaceModel';

@Component({
  selector: 'app-listing-option',
  templateUrl: './listing-option.component.html',
  styleUrls: ['./listing-option.component.css']
})
export class ListingOptionComponent implements OnInit {
  rows: SelectItem[];
  items: ListingOptionResponse[];
  selectedRows: number;
  filteredRecords: number;
  rowEvent: LazyLoadEvent;
  loading: boolean;
  totalRecords: number;
  error: Message[];
  isEditMode: boolean = false;
  ViewTypeEnum = ViewTypeEnum;
  constructor(
    private service: ListingOptionsService,
    public storageService: StorageService,
    private router: Router
  ) {
    this.loading = true;
    this.rows = [];
    this.rows.push({ label: '10', value: 10 });
    this.rows.push({ label: '25', value: 25 });
    this.rows.push({ label: '50', value: 50 });
    this.selectedRows = 10;
  }

  ngOnInit() {}

  changeRows(event): void {
    this.load(this.rowEvent);
  }

  reset(dt: DataTable, gb: HTMLInputElement) {
    gb.value = '';
    dt.reset();
  }

  deleteOption(option: ListingOptionResponse) {
    this.service.delete(option.Id).then(
      () => {
        this.items = this.items.filter(item => item.Id !== option.Id);
      },
      error => {
        this.error = [];
        this.error.push({ severity: 'error', summary: 'Error', detail: error });
      }
    );
  }

  edit(option: ListingOptionResponse) {
    this.router.navigate(['/marketplace/listing-options/edit/' + option.Id]);
  }

  load(event: LazyLoadEvent): void {
    this.loading = true;
    event.rows = this.selectedRows;
    this.rowEvent = event;

    this.service.search(event).then(
      dataPager => {
        this.items = dataPager.Data;
        this.filteredRecords = dataPager.FilteredRecords;
        this.totalRecords = dataPager.TotalRecords;
        this.loading = false;
      },
      error => {
        this.loading = false;
        this.items = [];
        this.totalRecords = 0;
        this.filteredRecords = 0;
        this.error = [];
        this.error.push({ severity: 'error', summary: 'Error', detail: error });
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/components/listing-option/listing-option.component.ts